import { createFileRoute } from "@tanstack/react-router";
import AdminResultados from "@/pages/AdminResultados";
import ProtectedRoute from "@/components/ProtectedRoute";

export const Route = createFileRoute("/admin-resultados")({
  head: () => ({
    meta: [{ title: "Admin Resultados | TiemposHoy" }, { property: "og:title", content: "Admin Resultados | TiemposHoy" }, { property: "og:type", content: "website" }, { name: "twitter:card", content: "summary" }, { name: "description", content: "Panel privado para cargar los resultados diarios de Nicaragua y Costa Rica." }, { property: "og:description", content: "Panel privado para cargar los resultados diarios de Nicaragua y Costa Rica." }, { name: "robots", content: "noindex, nofollow" }],
  }),
  component: () => (
    <ProtectedRoute>
      <AdminResultados />
    </ProtectedRoute>
  ),
});
